// extracted by mini-css-extract-plugin
export var attachment = "_q4-a";
export var emailContainer = "_q4-4";
export var emailContentPaddedContainer = "_q4-b";
export var emailHeader = "_q4-6";
export var emailIframe = "_q4-3";
export var emailInfoIcon = "_q4-9";
export var emailShortenedSummary = "_q4-e";
export var infoDropdown = "_q4-0";
export var infoRowBoundedContent = "_q4-d";
export var internal = "_q4-5";
export var merchant = "_q4-8";
export var messageInputContainer = "_q4-h";
export var normal = "_q4-7";
export var replyCard = "_q4-f";
export var subtleButton = "_q4-1";
export var subtleButtonIconContainer = "_q4-2";
export var toggleViewRepliesButton = "_q4-c";
export var wrappingText = "_q4-g";